import {Controller} from "stimulus";
import {showConfirmationDialog} from "./termination_dialog_controller";

export default class extends Controller {
  openConfirmationDialog() {
    showConfirmationDialog();
  }
}
